var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.065,
    height: 16.065,
    viewBox: "0 0 16.065 16.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49649",
    "data-name": "Group 49649",
    transform: "translate(-2307 -11911)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95207",
    "data-name": "Path 95207",
    d: "M8.033,0a8.033,8.033,0,1,0,8.033,8.033A8.032,8.032,0,0,0,8.033,0m.606,14.825v-.54a.606.606,0,1,0-1.213,0v.54a6.83,6.83,0,0,1-6.187-6.2h.522a.606.606,0,1,0,0-1.213H1.242A6.83,6.83,0,0,1,7.426,1.241v.5a.606.606,0,1,0,1.213,0v-.5a6.829,6.829,0,0,1,6.184,6.167H14.3a.606.606,0,1,0,0,1.213h.522a6.83,6.83,0,0,1-6.187,6.2",
    transform: "translate(2307 11911)",
    fill: "#44546f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95208",
    "data-name": "Path 95208",
    d: "M13.962,6.332l-3.591,3.763h-.021a.677.677,0,0,0-.131.013L7.214,7.835a.455.455,0,0,0-.547.727l3,2.27a.682.682,0,0,0,1.361-.057c0-.018,0-.035,0-.053l3.59-3.763a.455.455,0,1,0-.658-.628",
    transform: "translate(2304.682 11908.788)",
    fill: "#44546f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.052e2cc3273dab7dcbc925683606fe43.svg";
export { ForwardRef as ReactComponent };